import React, { useEffect, useState } from "react";
import { intl } from "LocaleWrapper";
import { Button } from "@cofano/cck";
import { Alert } from "@mui/material";
import SailingReportCreateEditDialog from "view/sailingreports/components/dialogs/SailingReportCreateEditDialog";
import { StatusVoyageEntity } from "types/index";
import { StatusFragmentFragment as StatusFragment } from "__generated__/view/statuses/graphql/fragments.generated";

type StatusChangerSailingReportFieldProps = {
	status?: StatusFragment;
	entities: StatusVoyageEntity[];
	onChange: (valid: boolean) => void;
};

const StatusChangerSailingReportField = ({ status, entities, onChange }: StatusChangerSailingReportFieldProps) => {

	const hasSailingReport = () => {
		return entities.length > 0 && entities.every(it => it.sailingReport);
	};

	const [ isValid, setValid ] = useState(hasSailingReport());
	const [ sailingReportDialogOpen, setSailingReportDialogOpen ] = useState(false);

	useEffect(() => {
		onChange(isValid);
	}, [ isValid ]);

	if (!status?.skipperRequiredFillInSailingReport) {
		return (
			<React.Fragment />
		);
	} else if (entities.length > 1 && !isValid) {
		return (
			<Alert severity="error">
				{intl.formatMessage({ id: "NOT_ALL_SELECTED_VOYAGES_HAS_SAILING_REPORT" })}
			</Alert>
		);
	} else if (entities.length === 1 && !isValid) {
		return (
			<div>
				<Button variant="text" onClick={() => setSailingReportDialogOpen(true)} size="small">
					{intl.formatMessage({ id: "SAILING_REPORT_ADD" })}
				</Button>

				<SailingReportCreateEditDialog
					open={sailingReportDialogOpen}
					onClose={() => setSailingReportDialogOpen(false)}
					voyage={entities[0]}
					onSailingReportAdd={() => setValid(true)}  />
			</div>
		);
	} else {
		return (
			<Alert severity="success">
				{intl.formatMessage({ id: "SAILING_REPORT" })}
			</Alert>
		);
	}
};

export default StatusChangerSailingReportField;
